<template>
    <span>
        <button class="p-link layout-topbar-chat" @click="openSidebar" v-tooltip.left="'Alterações de Estado de PATs'">
            <span class="layout-topbar-icon-wrapper">
                <span class="layout-topbar-icon pi pi-box"></span>
                <span class="chat-notification-ping" v-if="listStatusControl.length > 0" aria-hidden="true">
                    <span class="chat-notification-ping-outer"></span>
                    <span class="chat-notification-ping-inner"></span>
                </span>
            </span>
        </button>

    </span>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'StatusControlPatIndicator',
    data() {
        return {
            sidebarVisible: false,
        };
    },
    computed: {
        ...mapGetters('technicalManagement', [
            'listStatusControl'
        ])
    },
    created() {
        this.fetchData();
    },
    methods: {
        ...mapActions('technicalManagement', {
            fetchStatusControl: 'fetchStatusControl',
            toggleSidebarStatusControl: 'toggleSidebarStatusControl'
        }),
        async fetchData() {
            try {
                await this.fetchStatusControl();
            } catch (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Erro ao carregar dados',
                    life: 3000
                });
            }
        },
        openSidebar() {
            this.toggleSidebarStatusControl(true);
        }
    },
};
</script>